export default "__VITE_ASSET__caqtotdt__"